import { f as c } from "./index743.mjs";
import { a as o } from "./index777.mjs";
var n = c, e = o, f = function(r, a, t) {
  try {
    return n(e(Object.getOwnPropertyDescriptor(r, a)[t]));
  } catch {
  }
};
export {
  f
};
